{
  "version": 1,
  "asset_id": "b45accdf-5a0b-44d3-bf3b-1f7e613d0c09",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/b45accdf-5a0b-44d3-bf3b-1f7e613d0c09/home-video-new-poster.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/b45accdf-5a0b-44d3-bf3b-1f7e613d0c09/home-video-new-poster.jpg",
  "original_filename": "home-video-new-poster.jpg",
  "size": 193677,
  "content_type": "image/jpeg",
  "created_at": "2026-08-31T18:30:36Z"
}
